import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination,Mousewheel,Navigation } from 'swiper/modules';
import './App.css';
import Intro from './components/Intro';
import Project from './components/Project';
import Stack from './components/Stack';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

function App() {

  
  return (
    <>
    <Swiper
        mousewheel={true}
        direction='vertical'
        effect={'coverflow'}
        grabCursor={false}
        centeredSlides={true}
        slidesPerView={'auto'}
        spaceBetween={0}
        coverflowEffect={{
          rotate: 0,
          stretch: 100,
          depth: 0,
          modifier: 1,
          slideShadows: false,
        }}
        navigation
        pagination={true}
        modules={[EffectCoverflow, Pagination, Mousewheel]}
        className="w-screen h-screen"
        
      >
        <SwiperSlide><Intro/></SwiperSlide>
        
        <SwiperSlide><Project/></SwiperSlide>

        <SwiperSlide><Stack/></SwiperSlide>

      </Swiper>
    
      
      
      
    
    </>
  );
}

export default App;
